const $ = jQuery;

export default function () {
    if ($('.case-intro').length === 0) return;

    $('.case-intro__item-heading').on('click', function () {
        if (window.innerWidth < 1024) {
            $(this).next('.case-intro__item-links').slideToggle();
            $(this).toggleClass('active');
        }
    });

    $('.case-intro__items-trigger').on('click', function () {
        $('.case-intro__items').slideToggle();
        $(this).toggleClass('active');
    });

    $(window).on('resize', function () {
        if (window.innerWidth > 1024) {
            $('.case-intro__item-links').show();
        }
    });
}
